import { TurnFieldProposal } from "./slopifyThread";

const sortedStringify = (val: unknown): string => {
  if (val === null || typeof val !== "object") return JSON.stringify(val);
  if (Array.isArray(val)) return `[${val.map(sortedStringify).join(",")}]`;
  const sorted = Object.keys(val as Record<string, unknown>)
    .sort()
    .map((k) => `${JSON.stringify(k)}:${sortedStringify((val as Record<string, unknown>)[k])}`);
  return `{${sorted.join(",")}}`;
};

const deepEqual = (a: unknown, b: unknown): boolean => {
  if (a === b) return true;
  if (a === null || b === null || a === undefined || b === undefined) return false;
  if (typeof a !== typeof b) return false;
  if (typeof a !== "object") return false;
  if (Array.isArray(a) !== Array.isArray(b)) return false;
  try {
    return sortedStringify(a) === sortedStringify(b);
  } catch {
    return false;
  }
};

export interface BuildProposalArgs {
  generatedData: Record<string, unknown>;
  currentFormValues: Record<string, unknown>;
}

export interface BuildProposalResult {
  fields: TurnFieldProposal[];
}

export const buildProposal = ({
  generatedData,
  currentFormValues,
}: BuildProposalArgs): BuildProposalResult => {
  const fields: TurnFieldProposal[] = Object.entries(generatedData).map(([fieldName, after]) => {
    const before = currentFormValues?.[fieldName];
    return {
      fieldName,
      before,
      after,
      unchanged: deepEqual(before, after),
    };
  });
  return { fields };
};
